<template>
  <header class="app-header sticky top-0 z-30 flex h-[53px] shrink-0 items-center justify-between px-3 sm:px-6">
    <div class="header-brand flex items-center gap-2.5">
      <span class="text-xl select-none" aria-hidden="true">🦉</span>
      <span class="font-bold tracking-tight text-base sm:text-lg text-[var(--ui-text)]">Geobu</span>
      <UiBadge v-if="currentDeck" variant="neutral" size="sm" class="hidden sm:inline-flex">
        {{ currentDeck }}
      </UiBadge>
    </div>

    <div
      data-testid="account-sync-card"
      class="account-sync-card flex shrink-0 items-center gap-1 rounded-full p-[3px] sm:mr-6"
    >
      <SyncIndicator compact />
      <UserMenu
        :trigger-size="32"
        @open-preferences="$emit('open-preferences')"
        @open-login="$emit('open-login')"
      />
    </div>
  </header>
</template>

<script setup lang="ts">
import { UiBadge } from '../ui';
import SyncIndicator from './SyncIndicator.vue';
import UserMenu from './UserMenu.vue';

defineProps<{
  currentDeck?: string;
}>();

defineEmits<{
  'open-preferences': [];
  'open-login': [];
}>();
</script>

<style scoped>
.app-header {
  background: transparent;
  color: var(--ui-text);
}
.account-sync-card {
  border: 1px solid var(--ui-border-control);
  background: color-mix(in srgb, var(--ui-surface) 36%, transparent);
  box-shadow: var(--ui-shadow);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
</style>
